import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { ConvenienceTestDraftParams, ConvenienceTestDraftResponse } from '@repo/user-types'

const initialState: GenericOperationState<ConvenienceTestDraftResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: convenienceTestsDraftActions, reducer: convenienceTestsDraftReducer } =
  createOperationSlice<
    ConvenienceTestDraftResponse | null,
    SliceCaseReducers<GenericOperationState<ConvenienceTestDraftResponse | null>>,
    ConvenienceTestDraftParams
  >({
    name: '@users/convenienceTestsDraft',
    initialState,
    reducers: {},
  })
